(function () {
  "use strict";
  if (window.SAEProductInfo) { window.SAEProductInfo.initialize(); return; }
  function addDays(base, amount, business) {
    var date = new Date(base.getFullYear(), base.getMonth(), base.getDate(), 12);
    var remaining = Math.max(0, Math.min(180, Math.round(Number(amount) || 0)));
    while (remaining > 0) { date.setDate(date.getDate() + 1); if (!business || (date.getDay() !== 0 && date.getDay() !== 6)) remaining--; }
    return date;
  }
  function initialize() {
    document.querySelectorAll("[data-sae-product-info]").forEach(function (root) {
      if (root.dataset.saeInfoBound) return;
      var target;
      try { target = document.querySelector(root.dataset.target || "#shopify-section-product-navigation"); } catch (_) {}
      var host = root.closest(".shopify-section") || root;
      if (target && !host.contains(target)) target.insertAdjacentElement("afterend", host);
      var tabs = Array.from(root.querySelectorAll('[role="tab"]'));
      var panels = Array.from(root.querySelectorAll("[data-sae-info-panel]"));
      function select(index, focus) {
        tabs.forEach(function (tab, i) { tab.setAttribute("aria-selected", String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
        panels.forEach(function (panel, i) { panel.hidden = i !== index; });
        if (focus) tabs[index].focus();
      }
      tabs.forEach(function (tab, index) {
        tab.addEventListener("click", function () { select(index, false); });
        tab.addEventListener("keydown", function (e) {
          var next;
          if (e.key === "ArrowRight") next = (index + 1) % tabs.length;
          else if (e.key === "ArrowLeft") next = (index + tabs.length - 1) % tabs.length;
          else if (e.key === "Home") next = 0;
          else if (e.key === "End") next = tabs.length - 1;
          if (next !== undefined) { e.preventDefault(); select(next, true); }
        });
      });
      root.querySelector('[role="tablist"]').hidden = false;
      root.querySelectorAll("[data-sae-panel-heading]").forEach(function (heading) { heading.hidden = true; });
      select(root.dataset.defaultTab === "shipping" ? 1 : 0, false);
      var dates = root.querySelector("[data-sae-delivery-dates]");
      var min = Number(root.dataset.minDays), max = Number(root.dataset.maxDays);
      if (dates && max > 0 && min >= 0 && max >= min) {
        try {
          var formatter = new Intl.DateTimeFormat(document.documentElement.lang || undefined, { month: "short", day: "numeric" });
          var business = root.dataset.dayType !== "calendar", now = new Date();
          dates.textContent = "Estimated arrival: " + formatter.format(addDays(now, min, business)) + " – " + formatter.format(addDays(now, max, business));
          dates.hidden = false;
        } catch (_) {}
      }
      root.dataset.saeInfoBound = "true";
    });
  }
  window.SAEProductInfo = { initialize: initialize, addDays: addDays };
  initialize(); document.addEventListener("shopify:section:load", initialize);
})();
